import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Logo';

const Hero = () => {
    return (
        <div className="self-stretch px-8 pb-0 pt-8 relative bg-gradient-to-br from-blue-600 to-blue-700 overflow-hidden">
            <div className="absolute left-24 bottom-0 lg:top-0 opacity-40 w-[462px] h-[462px] lg:w-[600px] lg:h-[600px] z-0">
                <Logo width="100%" height="100%" logoFill="#6b21a8" mobile={true} />
            </div>
            <div className="w-[494.84px] h-[497.50px] absolute right-32 -bottom-[26rem] rotate-[8.60deg] opacity-30 bg-purple-800 rounded-full hidden lg:block"></div>

            <div className="max-w-7xl mx-auto relative z-10">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                    <div className="flex flex-col gap-6 justify-center pb-24 order-1 lg:order-2">
                        <div className="flex flex-col gap-4">
                            <h1 className="!text-white text-4xl lg:text-5xl font-bold font-['Montserrat'] leading-tight">
                                The Only AI Assistant That Actually Works With Your Team
                            </h1>
                            <p className="!text-white text-lg font-medium font-['Inter'] leading-relaxed">
                                Deploy a digital teammate that manages your calendar, handles payments, and coordinates with your physical staff in real-time to resolve complex caller questions.
                            </p>
                        </div>
                        <div className="flex flex-wrap gap-4">
                            <Link to="/signup">
                                <div className="px-6 py-3 bg-white rounded flex justify-center items-center gap-2.5 hover:bg-gray-100 transition-colors cursor-pointer">
                                    <div className="text-blue-600 text-sm font-bold font-['Inter']">Hire Your Assistant</div>
                                </div>
                            </Link>
                            {/*<Link to="#demo">*/}
                            {/*    <div className="px-6 py-3 rounded border border-white flex justify-center items-center gap-2 hover:bg-white/10 transition-colors cursor-pointer">*/}
                            {/*        <i className="fa fa-phone text-white"></i>*/}
                            {/*        <div className="text-white text-sm font-bold font-['Inter']">Hear a Live Demo</div>*/}
                            {/*    </div>*/}
                            {/*</Link>*/}
                        </div>
                    </div>

                    <div className="relative flex justify-center lg:justify-start items-center order-2 lg:order-1 z-20 py-12 lg:py-0">
                        <div className="w-full max-w-lg">
                            <div style={{ position: 'relative', overflow: 'hidden', aspectRatio: '16/9' }}>
                                <iframe 
                                    src="https://www.youtube.com/embed/BqHasFpfN6g" 
                                    title="YouTube video player" 
                                    allowFullScreen 
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                    style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, border: 'none', padding: 0, margin: 0, overflow: 'hidden' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;
